"use strict";

var _classCallCheck = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var rxjs_addons_1 = require("rxjs-addons");

var operators_1 = require("rxjs/operators");

var Action = /*#__PURE__*/function () {
  function Action(options) {
    _classCallCheck(this, Action);

    this.options = options;
    this.$incoming = new rxjs_addons_1.UniqueBehaviorSubject(null);
    this.$accepted = new rxjs_addons_1.UniqueBehaviorSubject(null); //
  }

  _createClass(Action, [{
    key: "setup",
    value: function setup() {
      var _this = this;

      return this.options && this.options.autoAccept ? this.$incoming.pipe(operators_1.filter(function (action) {
        return !!action;
      }), operators_1.tap(function () {
        return _this.acceptAction();
      })).subscribe() : null;
    }
  }, {
    key: "acceptAction",
    value: function acceptAction() {
      var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!action) {
        action = this.$incoming.value;

        if (action) {
          this.$incoming.next(null);
        }
      }

      if (action) {
        this.$accepted.next(action);
      }
    }
  }, {
    key: "dismissAction",
    value: function dismissAction() {
      this.$incoming.next(null);
      this.$accepted.next(null);
    }
  }], [{
    key: "createAction",
    value: function createAction(type, payload) {
      return {
        type: type,
        payload: payload,
        timestamp: Date.now()
      };
    }
  }]);

  return Action;
}();

exports.Action = Action;

(function (Action) {
  var Types;

  (function (Types) {
    Types["RequestAddAccountDevice"] = "RequestAddAccountDevice";
    Types["AccountDeviceAdded"] = "AccountDeviceAdded";
    Types["RequestSignSecureCode"] = "RequestSignSecureCode";
  })(Types = Action.Types || (Action.Types = {}));
})(Action = exports.Action || (exports.Action = {}));